import apiSlice from './ApiSlice';

export const channelApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // GET ALL
        getAllChannel: builder.query({
            providesTags: ["channel"],
            query: () => {
                return {
                    url: '/channel',
                    method: 'GET',
                };
            },
        }),

         // GET ALL With PAGINATION
         getAllChannelWithPagination: builder.query({
            providesTags: ["channel"],
            query: () => {
                return {
                    url: '/channel',
                    method: 'POST',
                };
            },
        }),

        // Add 
        addChannel: builder.mutation({
            invalidatesTags: ["channel"],
            query: (body) => {
                return {
                    url: '/channel/add',
                    method: 'POST',
                    body
                };
            },
        }),

        // EDIT
        editChannel: builder.mutation({
            invalidatesTags: ["channel"],
            query: ({ body, id } : any) => {
                return {
                    url: `/channel/${id}`,
                    method: 'PUT',
                    body
                };
            },
        }),

        //Single View
        viewChannelById: builder.query({
            providesTags: ["channel"],
            query: (id: any) => {
                return {
                    url: `/channel/${id}`,
                    method: "GET",
                };
            },
        }),

        // Delete
        deleteChannel: builder.mutation({
            invalidatesTags: ["channel"],
            query: (id: string) => {
                return {
                    url: `/channel/${id}`,
                    method: 'DELETE',
                };
            },
        }),

    }),

});

export const { useGetAllChannelQuery, useAddChannelMutation, useEditChannelMutation, useViewChannelByIdQuery, useDeleteChannelMutation , useGetAllChannelWithPaginationQuery } = channelApi;